<script lang="ts">
  import { Column, Grid, NumberInput, Row } from "carbon-components-svelte";
  import { ShoppingCart } from "carbon-icons-svelte";

  export let editMode: boolean;
  export let ProductId: string;
  let buttonText = editMode ? "Update" : "Add to Cart";
</script>

<div id="action-btns" style="padding-top:1rem">
  <Grid noGutter>
    <Row>
      <Column>
        <NumberInput
          id="product_enteredQuantity_{ProductId}"
          name="addtocart_{ProductId}.EnteredQuantity"
          min={1}
          max={1000}
          value={1}
          invalidText="The Qty field is required."
          label="Qty"
        />
      </Column>
      <Column padding>
        <button
          type="button"
          tabindex="0"
          class="bx--btn bx--btn--primary nopAjaxCartProductVariantAddToCartButton hideOnMobile"
          id="add-to-cart-button-{ProductId}"
          data-productid={ProductId}
        >
          {buttonText}
          <ShoppingCart class="bx--btn__icon" />
        </button>
        <button
          type="button"
          tabindex="0"
          class="bx--btn bx--btn--primary add-to-cart-button showOnMobile"
          id="add-to-cart-button-{ProductId}"
          data-productid={ProductId}
          onclick="return AjaxCart.addproducttocart_details('/addproducttocart/details/{ProductId}/1','form'),!1"
        >
          {buttonText}
          <ShoppingCart class="bx--btn__icon" />
        </button>
      </Column>
    </Row>
  </Grid>
</div>
